import { $axiosPublicContentJSON } from "../../common/utils/axiosUtils";

export const checkOrgLogin = (payload: string): any => {
  return $axiosPublicContentJSON.post(`/organization/search`, payload);
};
